import { Injectable, Logger } from '@nestjs/common';
import { Oid } from '@ip6m/types';
import { HuaweiOidDB } from './huawei_oid.service';
import { OidDB } from './oid.service';
import { OltDB } from './olt_database.service';

const snmp = require("net-snmp");
@Injectable() 
export class SnmpService {
    
    private options = {
        version: snmp.Version2c,
        timeout: 2000
    };
    constructor(private oltDB: OltDB, private oidDB: OidDB, private huawei_oidDB: HuaweiOidDB) {
        
    };

    set(oltid: number, oids: Array<Oid>) : Promise<Oid[]> {
        const olt = this.oltDB.getOlt(oltid);
        const result = [];

        const session = snmp.createSession (olt['ipaddress'], olt['write community'], this.options);
        
        return new Promise((resolve, reject) => {
            try {
            session.set (oids, function (error, varbinds) {
                if(error) {
                    Logger.warn('Snmp.set error: ' + error);
                    reject(error);
                } else {
                    for (let i = 0; i < varbinds.length; i++)
                        if (snmp.isVarbindError (varbinds[i])) {
                            Logger.warn('Snmp.set error: ' + error);
                            reject(snmp.varbindError (varbinds[i]));
                        } else {
                            result.push(varbinds[i]);
                        }
                    resolve(result);  
                }
                session.close();
            })}
            catch (error) {
                Logger.error('Snmp.set error: ' + error);
            }
        });        
    };
        
    get(oltid: number, oids: Array<string>) : Promise<Oid[]> {
                
        const olt = this.oltDB.getOlt(oltid);
        const result = [];
        
        const session = snmp.createSession (olt['ipaddress'], olt['read community'], this.options);

        return new Promise((resolve, reject) => {
            try {
            session.get (oids, function(error, varbinds) {
                if (error) {
                    Logger.warn('SNMP.get error: ' + error);
                    reject(error);
                } else {
                    for (let i = 0; i < varbinds.length; i++)
                        if (snmp.isVarbindError (varbinds[i])) {
                            Logger.warn('SNMP.get error: ' + error);
                            reject(snmp.varbindError (varbinds[i]));
                        } else {
                            result.push(varbinds[i]);
                        }
                    resolve(result);
                }
                session.close();
            })}
            catch(error) {
                Logger.error('SNMP.get error: ' + error);
            }
        });       
    };

    subtree(oltid: number, oid: string): Promise<Oid[]> {
    
        const olt = this.oltDB.getOlt(oltid);
        const result = [];
        
        const session = snmp.createSession (olt['ipaddress'], olt['read community'], this.options);

        return new Promise((resolve, reject) => {
            try {
            session.subtree (oid, function(varbinds) {
                        for (let i = 0; i < varbinds.length; i++)
                            if (snmp.isVarbindError (varbinds[i])) {
                                Logger.warn('SNMP.subtree error: ' + snmp.varbindError(varbinds[i]));
                                reject(snmp.varbindError (varbinds[i]));
                            } else {
                                let value;
                                // if(varbinds[i].type === 4) {
                                   // value = new TextDecoder().decode(varbinds[i].value);
                                //} else {
                                    value = varbinds[i].value;
                                //}
                                result.push({
                                    'oid': varbinds[i].oid,
                                    'type': varbinds[i].type,
                                    'value': value
                                });
                                
                            }                
            }, function(error) {
                session.close();
                if (error) {
                    reject('error');
                    Logger.error('SNMP.subtree error: ' + error);
                } else {
                    resolve(result);
                }
            })}
            catch(error) {
                Logger.error('SNMP.subtree error: ' + error);
            }
        });       
    };

    table(oltid: number, oid: string): Promise<Object> {

        const olt = this.oltDB.getOlt(oltid);
        const session = snmp.createSession (olt['ipaddress'], olt['read community'], this.options);

        return new Promise((resolve, reject) => {
            try {
            session.table(oid, (error, table) => {
                if(error) {
                    Logger.warn('SNMP.table error: ' + error);
                    reject(error);
                }
                else {
                    resolve(table);
                }                        
            })}
            catch(error){
                Logger.error('SNMP.table error: ' + error);
            }
        });       
    }
}



